import { render, staticRenderFns } from "./SilosAndShipments.vue?vue&type=template&id=153d6242&scoped=true&"
import script from "./SilosAndShipments.vue?vue&type=script&lang=js&"
export * from "./SilosAndShipments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153d6242",
  null
  
)

export default component.exports